'use client';

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { ChatPopup } from './ChatPopup';
import styles from './ChatPopup.module.css';

export function AIChatWidget({
  listingData = null,
  reviews = [],
  tenantId = null,
  userId = null,
  theme = 'light',
  primaryColor = '7c3aed',
  mode = 'context-chat',
  baseUrl = process.env.REACT_APP_CHAT_WIDGET_URL,
  title = 'GoPilot™ — Here to help',
  isOpen: controlledOpen,
  onOpenChange,
  hideTrigger = false
}) {
  const [internalOpen, setInternalOpen] = useState(false);
  const isOpen = controlledOpen !== undefined ? controlledOpen : internalOpen;

  const setIsOpen = newValue => {
    if (controlledOpen !== undefined) {
      // notify parent
      onOpenChange && onOpenChange(newValue);
    } else {
      setInternalOpen(newValue);
    }
  };

  const toggleChat = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      {!isOpen && !hideTrigger && (
        <button className={styles.triggerButton} onClick={toggleChat}>
          {title}
        </button>
      )}

      {/* Chat popup - always mounted (so the iframe persists) but rendered
          into a portal; ChatPopup controls its own visibility via isOpen */}
      <ChatPopup
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        listingData={listingData}
        reviews={reviews}
        tenantId={tenantId}
        userId={userId}
        theme={theme}
        primaryColor={primaryColor}
        mode={mode}
        baseUrl={baseUrl}
        title={title}
      />
    </>
  );
}

AIChatWidget.propTypes = {
  listingData: PropTypes.object,
  reviews: PropTypes.array,
  tenantId: PropTypes.string,
  userId: PropTypes.string,
  theme: PropTypes.oneOf(['light', 'dark']),
  primaryColor: PropTypes.string,
  mode: PropTypes.string,
  baseUrl: PropTypes.string,
  title: PropTypes.string,
  isOpen: PropTypes.bool,
  onOpenChange: PropTypes.func,
  hideTrigger: PropTypes.bool,
};